






























import Vue from 'vue';
import Block from './Block.vue';
import SectionHeading from './SectionHeading.vue';
export default Vue.extend({
    components: { Block, SectionHeading },
});
